<template>
  <div
    :id="`${source}_conferencing_apps`"
    class="flex flex-col gap-2 proxima_nova"
  >
    <div
      v-for="(app, index) in modelValue"
      :key="`${app?.id}_app_${index}`"
      class="flex flex-row w-full items-center justify-between rounded-lg p-4 bg_2 border_8"
    >
      <div class="flex flex-row items-center gap-6">
        <img
          class="size-14 rounded-lg border_8"
          :src="app?.icon"
          :alt="`${app?.title}_icon`"
        />
        <span class="text-base font-semibold">{{ app?.title }}</span>
      </div>

      <div class="flex">
        <div v-if="app?.is_enabled" class="flex">
          <a-button
            v-if="!app?.auto_record"
            class="primary_medium"
            :loading="app?.toggleInProgress"
            @click="toToggleAutoRecord(app?.id)"
            >{{
              app?.toggleInProgress ? "Enabling.." : "Enable Auto Recording"
            }}</a-button
          >
          <a-button
            v-else
            class="secondary_medium"
            :loading="app?.toggleInProgress"
            @click="toToggleAutoRecord(app?.id)"
            >{{
              app?.toggleInProgress ? "Disabling.." : "Disable Auto Recording"
            }}</a-button
          >
        </div>

        <a-button v-else class="secondary_medium" disabled
          >Coming soon...</a-button
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { message } from "ant-design-vue";
import DashboardService from "@/src/api/DashboardService.js";

const props = defineProps({
  source: { type: String, required: true },
  modelValue: { type: Object, required: true },
});

const emit = defineEmits(["update:modelValue"]);

const conferencingApps = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const toToggleAutoRecord = async (id) => {
  try {
    if (!id) return;

    // Set loading state for the specific app
    conferencingApps.value = conferencingApps.value?.map((app) =>
      app.id === id ? { ...app, toggleInProgress: true } : app,
    );

    const payload = {
      vendor: id,
    };

    const response = await DashboardService.toggleAutoRecord(payload);
    if (response?.success) {
      const details = conferencingApps.value.find((app) => app.id === id);

      conferencingApps.value = conferencingApps.value?.map((app) =>
        app.id === id ? { ...app, auto_record: !app?.auto_record, toggleInProgress: false } : app,
      );
      message.success(
        `Auto Record is ${details?.auto_record ? "disabled" : "enabled"} for ${details?.title} `,
      );
    }
  } catch (error) {
    console.error("An error occurred while toggling auto record: ", error);
    // Reset loading state on error
    conferencingApps.value = conferencingApps.value?.map((app) =>
      app.id === id ? { ...app, toggleInProgress: false } : app,
    );
  }
};
</script>
